module.exports = __webpack_public_path__ + "img/bg.48c581a4.jpg";